import { finderScopeProps } from "#ce/shared/filters/props/finder-scope";
import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  ...finderScopeProps,
  /** Disables the filter's interactive controls. */
  disabled: booleanAttribute(),
  /**
   * The applied visit type, as the comma-joined id list the `visit_types` search
   * param carries. Matched against a row's `value`.
   */
  modelValue: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: "Visit Type",
  },
  /**
   * Per-category titles for the top-level rows, keyed by visit-type category
   * (`{"in-person": "In-person visits only"}`). A category with no entry keeps the
   * server's own wording. Arrives as a JSON string from the server-rendered mount.
   *
   * @type {Object|String}
   */
  categoryLabels: {
    type: [Object, String],
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: "appointment-type-filled",
  },
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /** Endpoint override for the visit-type options. */
  url: {
    type: String,
    default: undefined,
  },
  /**
   * Result models the search returns: any of `Physician` and `Location`, e.g. `["Location"]`.
   * Sent with every options request so only their visit types are offered. Arrives as a JSON
   * string from the server-rendered mount.
   *
   * @type {Array|String}
   */
  resultTypes: {
    type: [Array, String],
    default: undefined,
  },
  /**
   * Hide the title bar at the top of the list.
   *
   * @type {Boolean|String}
   */
  hideTitleBar: booleanAttribute(),
  /**
   * Hide the pointer that joins the menu to its activator.
   *
   * @type {Boolean|String}
   */
  hidePointer: booleanAttribute(),
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  location: {
    type: String,
    default: undefined,
  },
  /**
   * Size the filter to its content instead of filling its container.
   *
   * @type {Boolean|String}
   */
  inline: booleanAttribute(),
  /**
   * Close the menu after an option is picked.
   *
   * @type {Boolean|String}
   */
  closeOnSelect: booleanAttribute(),
  /**
   * Show the options without letting the visitor pick one.
   *
   * @type {Boolean|String}
   */
  readonly: booleanAttribute(),
  /** Requires a visit type before form submission. @type {Boolean|String} */
  required: booleanAttribute(),
});
